import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { useCallback } from 'react'

type TProps = {
  statusList: string[]
  colorByStatus?: Record<string, string>
  stats?: Record<string, string>
  filters: string[]
  setFilters: React.Dispatch<React.SetStateAction<string[]>>
}

export function StatusSelect({ statusList, colorByStatus, stats, filters, setFilters }: TProps) {
  const handleChange = useCallback(
    (_: unknown, newFilters: string[]) => {
      setFilters(newFilters)
    },
    [setFilters]
  )

  if (!statusList?.length) return null

  return (
    <Stack mb={3}>
      <ToggleButtonGroup value={filters} onChange={handleChange} size="small">
        {statusList.map((state) => {
          const color = colorByStatus?.[state] || '#000000'
          const count = stats?.[state]

          return (
            <ToggleButton
              key={state}
              value={state}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 3,
                border: `1px solid ${color}`,
                color: color,
                px: 2,
                transition: 'all 0.2s ease',
                '&.Mui-selected': {
                  backgroundColor: color,
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: color,
                  },
                },
              }}
            >
              {state} ({count})
            </ToggleButton>
          )
        })}
      </ToggleButtonGroup>
    </Stack>
  )
}
